import React from 'react';
import {Button} from "antd";
import { ReloadOutlined } from '@ant-design/icons';


export const RefreshButton = ({fetch, loading}) =>
    <Button type="primary" loading={loading} onClick={fetch} icon={<ReloadOutlined />}  />
